// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"0a5cda6c","839":"48846161"}[chunkId] + ".chunk.js";
};